// extracted by mini-css-extract-plugin
export var active = "_1r-c";
export var activeIndicator = "_1r-7";
export var animate = "_1r-b";
export var contentWidthTabs = "_1r-5";
export var disabled = "_1r-d";
export var flat = "_1r-1";
export var fullWidth = "_1r-3";
export var lg = "_1r-a";
export var md = "_1r-9";
export var redoButtonTabGroup = "_1r-0";
export var sm = "_1r-8";
export var tabButton = "_1r-4";
export var tabButtonsContainer = "_1r-2";
export var xs = "_1r-6";